import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { useConfirmationModal } from '@bridebook/aura';
import { useWeddingWebsite } from '@bridebook/web/lib/wedding-website/hooks/query';
import { getIsWeddingWebsitePublished } from '@bridebook/web/lib/wedding-website/hooks/query/selectors';
import { useRsvpModal } from '@bridebook/web/components/wedding-website/rsvp/rsvp-modal.context';
import noop from 'lodash/noop';

/**
 * Wraps openPreviewModal with a publish guard — if the wedding website
 * is not published, shows a confirmation modal instead of opening preview.
 */
export const useRsvpPreviewWithPublishGuard = () => {
  const { t } = useTranslation('weddingWebsite');
  const { openPreviewModal } = useRsvpModal();
  const { data: isPublished } = useWeddingWebsite({ select: getIsWeddingWebsitePublished });
  const { openModal } = useConfirmationModal();

  return useCallback(() => {
    if (!isPublished) {
      openModal({
        title: t('rsvp.preview.publishGuard.title'),
        text: t('rsvp.preview.publishGuard.text'),
        primaryButtonText: t('rsvp.preview.publishGuard.primaryCta'),
        secondaryButtonText: '',
        secondaryButtonProps: { className: 'hidden' },
        onPrimaryButtonClick: noop,
      });
      return;
    }
    openPreviewModal();
  }, [isPublished, openModal, openPreviewModal, t]);
};
